import { createContext, useContext, useMemo } from 'react';
import { useUserSettings } from '../hooks/useUserSettings';
import { jsx as _jsx } from "react/jsx-runtime";
const ShareToolContext = /*#__PURE__*/createContext(null);
export const ProvideShareToolContext = ({
  footerRef,
  closeModal,
  children
}) => {
  const {
    data: userSettingsData,
    loading: userSettingsLoading
  } = useUserSettings();
  const userSettings = userSettingsData === null || userSettingsData === void 0 ? void 0 : userSettingsData.userSettings;
  const value = useMemo(() => ({
    footerRef,
    closeModal,
    userSettings,
    userSettingsLoading
  }), [footerRef, closeModal, userSettings, userSettingsLoading]);
  return /*#__PURE__*/_jsx(ShareToolContext.Provider, {
    value: value,
    children: children
  });
};
export const useShareToolContext = () => useContext(ShareToolContext);